import { LOGO_URL } from "../lib/api";

export function Logo({ size = 40, showText = false, className = "" }) {
  return (
    <div className={`flex items-center gap-2 ${className}`} data-testid="gh-logo">
      <img
        src={LOGO_URL}
        alt="Go Helper"
        style={{ height: size }}
        className="object-contain"
      />
      {showText && (
        <span className="font-heading font-black text-navy tracking-tight text-xl">
          Go Helper
        </span>
      )}
    </div>
  );
}
